import { render, staticRenderFns } from "./DistributeRules.vue?vue&type=template&id=9b843270&scoped=true&"
import script from "./DistributeRules.vue?vue&type=script&lang=ts&"
export * from "./DistributeRules.vue?vue&type=script&lang=ts&"
import style0 from "./DistributeRules.vue?vue&type=style&index=0&id=9b843270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b843270",
  null
  
)

export default component.exports